"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const Text = ({ widgetConfig, widgetStatus, i18n, interview, path, user }) => {
    if (!widgetStatus.isVisible) {
        return null;
    }
    const content = (0, helpers_1.translateString)(widgetConfig.text, i18n, interview, path, user);
    if ((0, LodashExtensions_1._isBlank)(content)) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "survey-section__text" },
        widgetConfig.containsHtml && react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
        !widgetConfig.containsHtml && (react_1.default.createElement("div", { className: (widgetConfig.align || 'left') + ' ' + (widgetConfig.classes ? widgetConfig.classes : '') },
            react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, content)))));
};
exports.Text = Text;
exports.default = (0, react_i18next_1.withTranslation)()(exports.Text);
//# sourceMappingURL=Text.js.map